<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'base-radio',
  props: {
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    value: {
      type: [String, Number, Boolean, Object],
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const isChecked = computed(() => {
      return props.modelValue === props.value
    })

    function onChange() {
      if (props.disabled) return
      emit('update:modelValue', props.value)
    }

    return {
      isChecked,
      onChange,
    }
  },
})
</script>

<template>
  <label
    class="relative flex items-center justify-center px-3 bg-gray-50 py-2 text-sm font-medium border rounded shadow-sm sm:flex-1 focus:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary transition-all duration-100"
    :class="[
      isChecked
        ? 'border-primary ring-1 ring-primary text-primary z-10'
        : 'border-input text-light hover:border-gray-400',
      disabled
        ? 'opacity-40 cursor-not-allowed'
        : 'cursor-pointer',
    ]"
  >
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      class="sr-only"
      @change="onChange"
    >
    <span :class="{ 'font-semibold': isChecked }">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>
